import { Component, OnInit, Input, ViewChild, Output, EventEmitter } from '@angular/core';
import {TranslateService} from '@ngx-translate/core';
import {MatDialog} from '@angular/material';
import {Utils} from '../../../../../../../common/services/Utils';
import {Language} from "../../../../../../../common/models/language";
import {LangChange} from '../../../../../../../lang-change';
import {FileService} from "../../../../../../shared/services/file.service";
import {FileServiceModerator} from "../../../../../../moderator/services/file-service-moderator.service";
import {AchievementFilteItem} from "./achievement-file-add/achievement-filte-item";

@Component({
  selector: 'app-achievement-files',
  templateUrl: './achievement-files.component.html',
  styleUrls: ['./achievement-files.component.scss']
})
export class AchievementFilesComponent extends LangChange implements OnInit {

  maxFileSize = 5012000;
  editItemId: number = -1;

  constructor(public _translateService: TranslateService,
              private fileService: FileService,
              private fileModeratorService: FileServiceModerator,
              private dialog: MatDialog,
              private utils: Utils) {
    super(_translateService);
  }

  @Input() public data: any[];
  @Input() public title: string;
  @Input() public showSelect: any[];
  @Input() public applicationFormDisabled: boolean;
  @ViewChild('fileInput') fileInputVariable;
  private item: AchievementFilteItem = new AchievementFilteItem();

  onLangChange(language: Language): void {
  }

  ngOnInit() {
    if (!this.showSelect) {
      this.showSelect = [null];
    }
  }

  editItem(i) {
    this.editItemId = i;
  }

  getFile(id: any) {
    this.utils.blockStart(null);
    this.fileService.getFileInfo(id).subscribe((fileInfo) => {
      this.fileService.getFile(fileInfo.fileId).subscribe((data) => {
        this.fileService.downloadPsFile(data, fileInfo);
        this.utils.blockStop();
      });
    });
  }

  deleteItem(i) {
    this.utils.confirmDialog({message: 'delete_confirmation'}, () => {
      if (this.data[i]['scan_copy_supporting_document']['fileId']) {
        this.fileModeratorService.deleteFile(this.data[i]['scan_copy_supporting_document']['fileId']).subscribe(res => {});
      }
      this.data.splice(i, 1);
    });
  }

  eventFromChild($event){
    if ($event) {
      this.editItemId = null;
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/modules/enroll/components/enroll-cabinet/tabs/enroll-personal-achievements/achievement-files/achievement-files.component.ts